<template>
    <div class="form-group">
        <lt-label
            :class="labelClass"
            :label="labelText"
        />
        <div
            :class="divClass"
            role="group">
            <button
                type="button"
                :class="LeftClass"
                @click="toggleLeft">
                {{ firstButtonText }}
            </button>
            <button
                type="button"
                :class="RightClass"
                @click="toggleRight">
                {{ secondButtonText }}
            </button>
        </div>
    </div>
</template>

<script>
    import LtLabel from './lt-label.vue';

    export default {
        components: {
            LtLabel,
        },
        props: {
            firstButtonText: {
                default: 'Yes',
            },
            secondButtonText: {
                default: 'No',
            },
            buttonClass: {
                default: 'btn-primary',
            },
            labelText: {
                default: 'Rent or Own',
            },
            currentSelection: {
                default: 'Yes',
            },
            labelClass: {
                default: '',
            },
            divClass: {
                default: 'btn-group',
            },
        },
        data() {
            return {
                CurrentSelection: this.currentSelection,
            };
        },
        computed: {
            LeftClass() {
                return this.CurrentSelection === this.firstButtonText ? 'btn selected' : 'btn';
            },
            RightClass() {
                return this.CurrentSelection === this.secondButtonText ? 'btn selected' : 'btn';
            },
        },
        methods: {
            toggleLeft() {
                this.CurrentSelection = this.firstButtonText;
                this.$emit('toggleSelectionChanged', this.firstButtonText);
            },
            toggleRight() {
                this.CurrentSelection = this.secondButtonText;
                this.$emit('toggleSelectionChanged', this.secondButtonText);
            },
        },
    };
</script>
<style lang="scss">
@import "../../assets/styles/variables";
#lt-yantr{
    .btn-group {
        width: 100%;
        .btn {
            display: inline-block;
            padding: 6px 12px;
            margin: 0;
            font-size: 14px;
            font-weight: 400;
            line-height: 1.42857143;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            -ms-touch-action: manipulation;
            touch-action: manipulation;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            border: 1px solid #333d48;
            border-radius: 4px;
            transition: all .3s;
            height: 40px;
            border: 1px solid #2aace3;
            width: 48%;
            background-color: #fff;
            color: #2aace3;
        }
        .btn:last-child:not(:first-child) {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
        }
        .btn:first-child {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
        }
        .btn:hover {
            color: #2aace3;
        }
        .btn:focus {
            color: #2aace3;
        }
        .selected {
            background-color: #2aace3;
            color: #fff;
        }
        .selected:hover {
            color: #fff;
        }
        .selected:focus {
            color: #fff;
        }
    }
    .toggle-buttons {
        width: 100%;
        .btn {
            font-size: 13px;
            line-height: 18px;
            padding: 8px 12px 8px 12px;
            border-radius: 0px;
            height: 40px;
        }
    }
    .label-margin{
        margin-left: 4px;
    }
    .btn-margin{
        margin-left: 8px;
         @media #{$laptop-view} {
            margin-left: 4px;
        }
    }
}

</style>
